module.exports = __webpack_public_path__ + "mpo-and-the-evolution-of-cvd.7b9f437c38cbda7bc2e3cba6f39c47e0.png";